exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".biography_Summary, .biography_welcomeMessage {\n    height : 100px;\n}\n.languageList {\n    display: -ms-flexbox;\n    display: flex;\n    min-height: 2em;\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n\n.languageList > span{\n    margin-bottom: 5px;\n}\n\n.isAvailable, .isDemo {\n    padding : 5px;\n}\n", ""]);

// exports
